import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { DteEmitido } from "../models/Dte/DteEmitido";
import { Response } from "src/app/shared/models/Response";
import { Observable } from "rxjs";
import { PaginationFilter } from "../shared/models/PaginationFilter";
import { PagedResponse } from "../shared/models/PagedResponse";
import { Page } from "../shared/models/Page";
import { DteFilter } from "../models/Dte/DteFilter";
import { DteEmitidoFile } from "../models/Dte/DteEmitidoFile";
import { Traza } from "../models/Traza";
import { NotaCredito } from "../models/NotaCredito";
import { DetalleDte } from "../models/Dte/DetalleDte";
import { Receptor } from "../models/Receptor/Receptor";
import { ReferenciaDte } from "../models/Dte/ReferenciaDte";
import { NotaDebito } from "../models/NotaDebito";
import { Proveedor } from "../models/Proveedor/Proveedor";
import { ComisionRecargo } from "../models/Dte/ComisionRecargo";
import { CesionRequest } from "../models/Cesion/CesionRequest";
import { IDte } from "../models/Dte/IDte";
import { InfoDetalladaDte } from "../models/InfoDetalladaDte";
import { FacturacionGuiaRequest } from "../models/Dte/FacturacionGuiaRequest";
import { ActualizarEstadoSiiRequest } from "../models/Dte/ActualizarEstadoSiiRequest";
import { ReenvioEmailRequest } from "../models/Dte/ReenvioEmailRequest";
import { Conciliacion, ImportacionBoletasSiiStatus, ImportacionBoletasSiiTotales } from "../models/Dte/Conciliacion";
import { ReutilizacionMasivaRequest } from "../models/Dte/ReutilzacionMasivaRequest";
import { InvoicingButton } from "src/app/shared/models/InvoicingButton.enum";
import { BehaviorSubject, Subject } from "rxjs";
import { MarcarPagadoOPendiente } from "src/app/models/MarcarPagadoOPendiente";
import { DescuentoRecargo } from "../models/Dte/DescuentoRecargo";
import { ResultadoDescargaMasiva } from "../models/Dte/ResultadoDescargaMasiva";
import { DteExportSummary } from "../models/Dte/DteExportSummary";

@Injectable({
	providedIn: "root",
})
export class DteEmitidosService {
	private REST_API_SERVER = environment.backend_server + "/dte";
	private REST_API_SERVER_ONVISION = environment.backend_server + "/Impresion";
	private REST_API_SERVER_DebitNote = environment.backend_server + "/NotaDebito";
	private REST_API_SERVER_DTE_EXPORT = environment.backend_server + "/Exportacion";
	private REST_API_SERVER_CESION = environment.backend_server + "/Cesion";
	private REST_API_SERVER_SETTLEMENT = environment.backend_server + "/LiquidacionFactura";
	private REST_API_SERVER_GUIDE = environment.backend_server + "/GuiaDespacho";
	private buttonActionsSubject: Subject<InvoicingButton>;
	public buttonActionsObservable: Observable<InvoicingButton>;

	private auth = {};
	constructor(private http: HttpClient) {
		this.buttonActionsSubject = new Subject<InvoicingButton>();
		this.buttonActionsObservable = this.buttonActionsSubject.asObservable();
	}

	public getData(emisorId: string): Observable<Response<DteEmitido[]>> {
		return this.http.get<Response<DteEmitido[]>>(this.REST_API_SERVER + "/list?emisorId=" + emisorId);
	}

	private appendQueryParam(params: HttpParams, key: string, value: any): HttpParams {
		if (value === null || value === undefined || value === "") {
			return params;
		}
		return params.append(key, String(value));
	}

	private appendArrayQueryParam(params: HttpParams, key: string, values: any): HttpParams {
		const source = Array.isArray(values) ? values : [values];
		source.forEach((value) => {
			if (value === null || value === undefined) {
				return;
			}
			const textValue = String(value).trim();
			if (textValue === "") {
				return;
			}
			params = params.append(key, textValue);
		});
		return params;
	}

	private buildEmitidosFilterParams(filtro: DteFilter): HttpParams {
		let params = new HttpParams();
		params = this.appendQueryParam(params, "emisorId", filtro.emisorId);
		params = this.appendQueryParam(params, "importacionMasivaId", filtro.importacionMasivaId);
		params = this.appendArrayQueryParam(params, "tipoDteId", filtro.tipoDteId);
		params = this.appendArrayQueryParam(params, "sucursalId", filtro.sucursalId);
		params = this.appendArrayQueryParam(params, "estadoSii", filtro.estadoSii);
		params = this.appendArrayQueryParam(params, "EstadoAcuse", filtro.estadoAcuse);
		params = this.appendQueryParam(params, "Importado", filtro.importado);
		params = this.appendQueryParam(params, "Reutilizado", filtro.reutilizado);
		params = this.appendQueryParam(params, "Nulos", filtro.nulos);
		params = this.appendQueryParam(params, "PuedenCederse", filtro.puedenCederse);
		params = this.appendQueryParam(params, "PendientePago", filtro.pendientePago);
		params = this.appendQueryParam(params, "TrackId", filtro.trackId);
		params = this.appendQueryParam(params, "montoTotal", filtro.montoTotal);
		params = this.appendQueryParam(params, "fechaDesde", filtro.fechaDesde);
		params = this.appendQueryParam(params, "fechaHasta", filtro.fechaHasta);
		params = this.appendQueryParam(params, "rutReceptor", filtro.rutReceptor);
		params = this.appendQueryParam(params, "rutReceptorDv", filtro.rutReceptor);
		params = this.appendQueryParam(params, "razonSocialReceptor", filtro.razonSocialReceptor);
		params = this.appendQueryParam(params, "codigoSii", filtro.codigoSii);
		params = this.appendQueryParam(params, "folio", filtro.folio);
		params = this.appendQueryParam(params, "AmbienteId", filtro.ambienteId);
		params = this.appendQueryParam(params, "ReceptorId", filtro.receptorId);
		params = this.appendQueryParam(params, "ClienteId", filtro.clienteId);
		params = this.appendQueryParam(params, "RutEmisor", filtro.rutEmisor);
		params = this.appendQueryParam(params, "FileType", filtro.fileType);
		return params;
	}

	public getDataToExport(filtro: DteFilter): Observable<DteEmitido[]> {
		return this.http.get<DteEmitido[]>(this.REST_API_SERVER + "/export", {
			params: this.buildEmitidosFilterParams(filtro),
		});
	}

	public getExportSummary(filtro: DteFilter): Observable<Response<DteExportSummary>> {
		return this.http.get<Response<DteExportSummary>>(this.REST_API_SERVER + "/export/summary", {
			params: this.buildEmitidosFilterParams(filtro),
		});
	}

	public getDataByPage(filtro: DteFilter, page: Page): Observable<PagedResponse<DteEmitido>> {
		let params = this.buildEmitidosFilterParams(filtro);
		params = this.appendQueryParam(params, "razonSocialProveedor", filtro.razonSocialProveedor);
		params = this.appendQueryParam(params, "pageNumber", page.pageNumber);
		params = this.appendQueryParam(params, "pageSize", page.pageSize);

		return this.http.get<PagedResponse<DteEmitido>>(this.REST_API_SERVER + "/list/filter", { params });
	}
	public getDataByPageForGuides(filtro: DteFilter, page: Page): Observable<PagedResponse<DteEmitido>> {
		let stringRut = "&rutReceptor=" + filtro.rutReceptor;
		if (filtro.rutReceptor == "") {
			stringRut = "";
		}
		let stringEstadoSii = filtro.estadoSii ? "&estadoSii=" + filtro.estadoSii : "";
		return this.http.get<PagedResponse<DteEmitido>>(
			this.REST_API_SERVER +
			"/listGuides/filter?emisorId=" +
			filtro.emisorId +
			"&importacionMasivaId=" +
			filtro.importacionMasivaId +
			"&TipoTraslado=" +
			filtro.tipoTraslado +
			"&TipoDespacho=" +
			filtro.tipoDespacho +
			"&Facturable=" +
			filtro.facturable +
			"&TrackId=" +
			(filtro.trackId != undefined ? filtro.trackId : "") +
			"&tipoDteId=" +
			filtro.tipoDteId +
			"&Reutilizado=" +
			(filtro.reutilizado != undefined ? filtro.reutilizado : "") +
			"&fechaDesde=" +
			(filtro.fechaDesde != undefined ? filtro.fechaDesde : "") +
			"&fechaHasta=" +
			(filtro.fechaHasta != undefined ? filtro.fechaHasta : "") +
			stringRut +
			"&razonSocialReceptor=" +
			(filtro.razonSocialReceptor != undefined ? filtro.razonSocialReceptor : "") +
			"&folio=" +
			(filtro.folio != undefined ? filtro.folio : "") +
			stringEstadoSii +
			"&rutReceptorDv=" +
			(filtro.rutReceptor != undefined ? filtro.rutReceptor : "") +
			"&SucursalId=" +
			(filtro.sucursalId ? filtro.sucursalId : "") +
			"&pageNumber=" +
			page.pageNumber +
			"&pageSize=" +
			page.pageSize
		);
	}

	public getDataByPageOnRVD(rvdId: string, emisorId: string, page: Page) {
		return this.http.get<PagedResponse<DteEmitido>>(this.REST_API_SERVER + "/list/filterbyrvd?registroVentaDiarioId=" + rvdId + "&emisorId=" + emisorId + "&pageNumber=" + page.pageNumber + "&pageSize=" + page.pageSize);
	}

	public getZip(request): Observable<Blob> {
		return this.http.post(this.REST_API_SERVER + "/download-zip", request, { responseType: 'blob' });
	}

	public getZipConResultado(request): Observable<Response<ResultadoDescargaMasiva>> {
		return this.http.post<Response<ResultadoDescargaMasiva>>(this.REST_API_SERVER + "/download-zip", request);
	}

	public getXml(dteId: string): Observable<Response<DteEmitidoFile>> {
		return this.http.get<Response<DteEmitidoFile>>(this.REST_API_SERVER + "/xml?dteId=" + dteId);
	}

	public getTrace(dteId: string): Observable<Response<Traza[]>> {
		return this.http.get<Response<Traza[]>>(this.REST_API_SERVER + "/trazabilidad?dteId=" + dteId);
	}

	public getPdf(dteId: string): Observable<Response<any>> {
		return this.http.get<Response<any>>(this.REST_API_SERVER_ONVISION + "/pdf/" + dteId + "/" + false + "/" + 0);
	}

	public regenerarPdf(dteId: string): Observable<Response<any>> {
		return this.http.get<Response<any>>(this.REST_API_SERVER_ONVISION + "/pdf/regenerar/" + dteId + "/" + false + "/" + 0);
	}

	public getPdfCedible(dteId: string, cedible: boolean): Observable<Response<any>> {
		return this.http.get<Response<any>>(this.REST_API_SERVER_ONVISION + "/pdf/" + dteId + "/" + cedible + "/" + 0);
	}
	public getPdfLiquidacion(dteId: string): Observable<Response<any>> {
		return this.http.get<Response<any>>(this.REST_API_SERVER_ONVISION + "/pdf/liquidacion?dteId=" + dteId);
	}
	// public sendDocumentToEmail(emailRequest: EmailRequest): Observable<any> {
	//   let request = {};
	//   request["auth"] = this.auth;
	//   request["email"] = emailRequest;
	//   return this.http.post<any>(EMAIL_API_SERVER + "/Send/Template", request);
	// }
	public getDetalleDte(dteId: string): Observable<Response<DetalleDte[]>> {
		return this.http.get<Response<DetalleDte[]>>(this.REST_API_SERVER + "/detalle?dteId=" + dteId);
	}
	public getComisionesDte(dteId: string): Observable<Response<ComisionRecargo[]>> {
		return this.http.get<Response<ComisionRecargo[]>>(this.REST_API_SERVER + "/comisiones?dteId=" + dteId);
	}
	public getReceptorDte(dteId: string): Observable<Response<Receptor>> {
		return this.http.get<Response<Receptor>>(this.REST_API_SERVER + "/receptor?dteId=" + dteId);
	}
	public getReceptorDteLiquidacion(dteId: string): Observable<Response<Receptor>> {
		return this.http.get<Response<Receptor>>(this.REST_API_SERVER + "/receptorLiquidacion?dteId=" + dteId);
	}
	public getProveedorDte(dteId: string): Observable<Response<Proveedor>> {
		return this.http.get<Response<Proveedor>>(this.REST_API_SERVER + "/proveedor?dteId=" + dteId);
	}

	public creditNoteNullification(note: NotaCredito): Observable<Response<DteEmitido>> {
		let formData = new FormData();

		switch (note.tipoNota) {
			case 0:
				//anulación
				formData.append("dteId", note.dteReferenciaId);
				formData.append("usuarioId", note.usuarioId);
				formData.append("motivo", note.motivoString);
				formData.append("razonRef", note.comentario);
				formData.append("fecha", note.fechaNota);
				return this.http.post<Response<DteEmitido>>(this.REST_API_SERVER + "/nota_credito/anulacion", formData);
				break;

			case 1: //montos
				formData.append("dteId", note.dteReferenciaId);
				formData.append("usuarioId", note.usuarioId);
				formData.append("detalleString", JSON.stringify(note.itemsNota));
				formData.append("motivo", note.motivoString);
				formData.append("razonRef", note.comentario);
				formData.append("fecha", note.fechaNota);
				formData.append("applyGlobalDiscount", String(note.applyGlobalDiscount === true));
				formData.append("globalDiscountValue", String(Number(note.globalDiscountValue ?? 0)));
				return this.http.post<Response<DteEmitido>>(this.REST_API_SERVER + "/nota_credito/corrige_monto", formData);

			case 2: //textos
				formData.append("dteId", note.dteReferenciaId);
				formData.append("usuarioId", note.usuarioId);
				formData.append("detalleString", JSON.stringify(note.itemsNota));
				formData.append("motivo", note.motivoString);
				formData.append("razonRef", note.comentarioCorreccionTexto);
				formData.append("fecha", note.fechaNota);
				return this.http.post<Response<DteEmitido>>(this.REST_API_SERVER + "/nota_credito/corrige_texto", formData);
		}
	}
	public creditNoteDteExportNullification(note: NotaCredito): Observable<Response<DteEmitido>> {
		let formData = new FormData();

		switch (note.tipoNota) {
			case 0:
				//default
				formData.append("dteId", note.dteReferenciaId);
				formData.append("usuarioId", note.usuarioId);
				formData.append("motivo", note.motivoString);
				formData.append("razonRef", note.comentario);
				return this.http.post<Response<DteEmitido>>(this.REST_API_SERVER_DTE_EXPORT + "/nota_credito/anulacion", formData);
		}
	}
	public debitNoteDteExportNullification(note: NotaDebito): Observable<Response<DteEmitido>> {
		let formData = new FormData();

		switch (note.tipoNota) {
			case 0:
				//default
				formData.append("dteId", note.dteReferenciaId);
				formData.append("usuarioId", note.usuarioId);
				formData.append("motivo", note.motivoString);
				formData.append("razonRef", note.comentario);
				return this.http.post<Response<DteEmitido>>(this.REST_API_SERVER_DTE_EXPORT + "/nota_debito/anulacion", formData);
		}
	}
	public debitNoteNullification(note: NotaDebito): Observable<Response<DteEmitido>> {
		let formData = new FormData();

		switch (note.tipoNota) {
			case 0:
				//default
				formData.append("dteId", note.dteReferenciaId);
				formData.append("usuarioId", note.usuarioId);
				formData.append("motivo", note.motivoString);
				formData.append("razonRef", note.comentario);
				formData.append("fecha", note.fechaNota);
				return this.http.post<Response<DteEmitido>>(this.REST_API_SERVER_DebitNote + "/anulacion", formData);
		}
	}
	public debitNoteNullificationInterests(note: NotaDebito): Observable<Response<DteEmitido>> {
		let formData = new FormData();

		switch (note.tipoNota) {
			case 0: //Intereses
				formData.append("dteId", note.dteReferenciaId);
				formData.append("usuarioId", note.usuarioId);
				formData.append("motivo", note.motivoString);
				formData.append("razonRef", note.comentario);
				if (note.exento > 0) {
					formData.append("exento", note.exento.toString());
					formData.append("iva", "0");
					formData.append("neto", "0");
				} else {
					formData.append("neto", note.neto.toString());
					formData.append("iva", note.iva.toString());
					formData.append("exento", "0");
				}
				formData.append("total", note.total.toString());
				formData.append("fecha", note.fechaNota);
				return this.http.post<Response<DteEmitido>>(this.REST_API_SERVER_DebitNote + "/intereses", formData);
		}
	}
	public getReferencias(dteId: string): Observable<Response<ReferenciaDte[]>> {
		return this.http.get<Response<ReferenciaDte[]>>(this.REST_API_SERVER + "/referencias?dteId=" + dteId);
	}

	public getReferenciasDte(dteId: string): Observable<Response<ReferenciaDte[]>> {
		return this.http.get<Response<ReferenciaDte[]>>(this.REST_API_SERVER + "/dtereferenciado?dteId=" + dteId);
	}

	public sendEmailBackend(emailList: string[], emailCopyList: string[], emailBlindCopyList: string[], dteList: string[], sendPdf: boolean, sendXml: boolean): Observable<Response<string>> {
		let formData = new FormData();
		formData.append("listaDteIds", JSON.stringify(dteList));
		formData.append("sendPdf", sendPdf.toString());
		formData.append("sendXml", sendXml.toString());
		formData.append("emailList", JSON.stringify(emailList));
		formData.append("copyEmails", JSON.stringify(emailCopyList));
		formData.append("blindCopyEmails", JSON.stringify(emailBlindCopyList));
		return this.http.post<Response<string>>(this.REST_API_SERVER + "sendDocumentsToEmail", formData);
	}

	public sendCesionRequest(usuarioId, sucursalId, cesionRequest: CesionRequest): Observable<Response<string>> {
		let formData = new FormData();
		formData.append("usuarioIdString", usuarioId);
		formData.append("sucursalIdString", sucursalId);
		formData.append("dteEmitidoEntString", JSON.stringify(cesionRequest));
		return this.http.post<Response<string>>(this.REST_API_SERVER_CESION + "/emitir", formData);
	}
	/*sendDteNegativeSettlement(usuarioId: string, sucursalId: string, dteId: string): Observable<Response<string>> {
		let formData = new FormData();
		formData.append("usuarioIdString", usuarioId);
		formData.append("sucursalIdString", sucursalId);
		formData.append("dteId", dteId);
		return this.http.post<Response<string>>(this.REST_API_SERVER_SETTLEMENT + "/emitirNegativa", formData);
	}*/

	sendDteNegativeSettlement(usuarioId: string, sucursalId: string, dteId: string, fechaEmision?: string,fechaVencimiento?: string) {
		const form = new FormData();
		form.append('usuarioIdString', usuarioId);
		form.append('sucursalIdString', sucursalId);
		form.append('dteId', dteId);
		if (fechaEmision) form.append('fechaEmisionString', fechaEmision);
		if (fechaVencimiento) form.append('fechaVencimientoString', fechaVencimiento);
		return this.http.post<Response<string>>(
			`${this.REST_API_SERVER_SETTLEMENT}/emitirNegativa`,
			form
		);
	}


	getInfoDetalleDte(dteId: string): Observable<InfoDetalladaDte> {
		return this.http.get<InfoDetalladaDte>(this.REST_API_SERVER + "/infodetallada?dteId=" + dteId);
	}

	guidesToInvoices(req: FacturacionGuiaRequest): Observable<Response<any>> {
		return this.http.post<Response<any>>(this.REST_API_SERVER_GUIDE + "/CreateInvoice", req);
	}

	public anularGuia(dteId: string, userId: string): Observable<Response<boolean>> {
		return this.http.post<Response<boolean>>(
		  this.REST_API_SERVER_GUIDE + "/anular",
		  {
			dteId: dteId,
			userId: userId
		  }
		);
	  }

	resendDte(request: ActualizarEstadoSiiRequest): Observable<Response<boolean>> {
		return this.http.post<Response<boolean>>(this.REST_API_SERVER + "/updateSiiStatus", request);
	}

	documentsOfClient(filtro: DteFilter, page: Page): Observable<PagedResponse<DteEmitido>> {
		let stringRut = "&rutReceptor=" + encodeURIComponent(filtro.rutReceptor || "");
		if (filtro.rutReceptor == "") {
			stringRut = "";
		}
		let stringEstadoSii = filtro.estadoSii ? "&estadoSii=" + filtro.estadoSii : "";
		return this.http.get<PagedResponse<DteEmitido>>(
			this.REST_API_SERVER +
			"/list/filter?emisorId=" +
			filtro.emisorId +
			"&importacionMasivaId=" +
			filtro.importacionMasivaId +
			"&tipoDteId=" +
			filtro.tipoDteId +
			"&fechaDesde=" +
			(filtro.fechaDesde != undefined ? filtro.fechaDesde : "") +
			"&fechaHasta=" +
			(filtro.fechaHasta != undefined ? filtro.fechaHasta : "") +
			stringRut +
			"&razonSocialReceptor=" +
			encodeURIComponent(filtro.razonSocialReceptor || "") +
			"&razonSocialProveedor=" +
			encodeURIComponent(filtro.razonSocialProveedor || "") +
			"&codigoSii=" +
			(filtro.codigoSii != undefined ? filtro.codigoSii : "") +
			"&folio=" +
			encodeURIComponent(filtro.folio || "") +
			stringEstadoSii +
			"&rutReceptorDv=" +
			encodeURIComponent(filtro.rutReceptor || "") +
			"&ReceptorId=" +
			(filtro.receptorId ? filtro.receptorId : "") +
			"&ClienteId=" +
			(filtro.clienteId || "") +
			"&SucursalId=" +
			(filtro.sucursalId ? filtro.sucursalId : "") +
			"&AmbienteId=" +
			(filtro.ambienteId != undefined ? filtro.ambienteId : "") +
			"&pageNumber=" +
			page.pageNumber +
			"&pageSize=" +
			page.pageSize
		);
	}
	resendEmailSii(request: ReenvioEmailRequest): Observable<Response<boolean>> {
		return this.http.post<Response<boolean>>(this.REST_API_SERVER + "/resendEmailSii", request);
	}
	importDteSii(conciliacion: Conciliacion): Observable<Response<string>> {
		return this.http.post<Response<string>>(this.REST_API_SERVER + "/importDteSII", conciliacion);
	}
	importBoletasSii(conciliacion: Conciliacion): Observable<Response<ImportacionBoletasSiiTotales>> {
		return this.http.post<Response<ImportacionBoletasSiiTotales>>(this.REST_API_SERVER + "/importBoletasSII", conciliacion);
	}
	getImportBoletasSiiStatus(emisorId: string, mes: number, anio: number): Observable<Response<ImportacionBoletasSiiStatus>> {
		return this.http.get<Response<ImportacionBoletasSiiStatus>>(
			this.REST_API_SERVER + "/importBoletasSII/status/" + emisorId + "?mes=" + mes + "&anio=" + anio
		);
	}

	reuse(dteId: string): Observable<Response<boolean>> {
		return this.http.get<Response<boolean>>(this.REST_API_SERVER + "/reuseFolio/" + dteId);
	}
	massivereuse(request: ReutilizacionMasivaRequest): Observable<Response<boolean>> {
		return this.http.post<Response<boolean>>(this.REST_API_SERVER + "/massiveReuseFolio", request);
	}

	// Reenvío de link/QR Payku (individual o masivo)
	reenviarLinkPayku(dtes: DteEmitido[]): Observable<Response<boolean>> {
		return this.http.post<Response<boolean>>(this.REST_API_SERVER + "/reenvio/payku", dtes);
	}

	public markAsInvoiced(dteIds: string[], userId: string): Observable<Response<boolean>> {
		return this.http.post<Response<boolean>>(
		  `${this.REST_API_SERVER_GUIDE}/markAsInvoiced`, 
		  { dteIds, userId }
		);
	  }
	marcarEstadoPago(request: any): Observable<Response<any>> {
		return this.http.post<Response<any>>(this.REST_API_SERVER + "/marcar-pagado", request);
	}
	getDescuentosRecargos(dteId: string) {
		return this.http.get<Response<DescuentoRecargo[]>>(
			`${this.REST_API_SERVER}/descuento-recargo-global/${dteId}`
		);
	}
}
